import { ORDER_STATES } from '@/pages/orders/orderRenewal/config'
import { getSensitiveRentOrderRenewalList, getRentOrderRenewalList, getLeaseOrderRenewalList } from '@/api/domain/underLease'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export const PERSONAL_ADD_PATH = '/underLease/orderRenewal/personalAdd'
export const ENTERPRISE_ADD_PATH = '/underLease/orderRenewal/enterpriseAdd'
export const ENTERPRISE_SUB_ADD_PATH = '/underLease/orderRenewal/enterpriseSubAdd'
export const ENTERPRISE_SUB_BATCH_ADD_PATH = '/underLease/orderRenewal/enterpriseSubBatchAdd'

export const TAB_MAP = {
  personal: {
    label: '个人租赁订单',
    value: 'personal',
    index: '0',
  },
  enterprise: {
    label: '企业租赁主订单',
    value: 'enterprise',
    index: '1',
  },
  enterpriseSub: {
    label: '企业租赁子订单',
    value: 'enterpriseSub',
    index: '2',
  },
}

export const TAB_LIST = [
  TAB_MAP.personal,
  TAB_MAP.enterprise,
  TAB_MAP.enterpriseSub,
]

export function CONFIG() {
  return {
    personalConfigData: {
      formData: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '车牌号',
              prop: 'carId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: true,
              remoteMethod: (query) => {
                this.gerCarList(query)
              },
              placeholder: '请输入',
              options: {
                label: 'plateNo',
                value: 'id',
                list: [],
              },
              events: {
                'visible-change': (visible) => {
                  if (!visible) {
                    this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
                  }
                },
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
              defaultFirstOption: true,
              remoteMethod: (query) => {
                this.getCustomerList(query)
              },
              placeholder: '请输入',
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              events: {
                'visible-change': (visible) => {
                  if (!visible) {
                    this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'customerId', data: [] })
                  }
                },
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '续约订单ID',
              prop: 'newOrderId',
            },
            directives: [{ name: 'number', arg: 'integer', value: 18 }],
            elConfig: {
              placeholder: '请输入',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '原订单ID',
              prop: 'oldOrderId',
            },
            directives: [{ name: 'number', arg: 'integer', value: 18 }],
            elConfig: {
              placeholder: '请输入',
            },
          },
          {
            itemConfig: {
              prop: 'brandSeriesModel',
            },
            elConfig: {
              showModel: true,
              filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
            },
            render: 'CarBrandSeriesModel',
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约单创建时间',
              prop: 'gmtCreate',
            },
            elConfig: {},
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约计租开始日',
              prop: 'renewalStartTime',
            },
            elConfig: {},
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约计租结束日',
              prop: 'renewalEndTime',
            },
            elConfig: {},
          },
        ],
        dealWithSearch: this.dealWithSearchOfPersonnal,
        customizeReset: this.resetBrandSeriesModel,
      },
      tableData: {
        columns: [
          {
            name: 'newOrderId',
            columnProps: {
              label: '续约订单ID',
              prop: 'newOrderId',
              width: 150,
            },
            render: ({ row }) => {
              const params = {
                path: '/underLease/underLeaseOrder/personalDetail',
                query: {
                  id: row.newOrderId,
                  orderType: 'personal',
                },
              }
              return <span class="a-hover-link" onClick={() => this.$router.push(params)} > {row.newOrderId} </span>
            },
          },
          {
            name: 'plateNo',
            columnProps: {
              label: '车牌号',
              prop: 'plateNo',
              width: 100,
            },
          },
          {
            name: 'brandName',
            columnProps: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            name: 'seriesName',
            columnProps: {
              label: '车系',
              prop: 'seriesName',
            },
          },
          {
            name: 'carModel',
            columnProps: {
              label: '车型',
              prop: 'carModel',
              width: 160,
            },
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
          {
            name: 'customerName',
            columnProps: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
          {
            name: 'rentCategory',
            columnProps: {
              label: '租赁类别',
              prop: 'rentCategory',
            },
          },
          {
            name: 'newOrderState',
            columnProps: {
              label: '续约订单状态',
              prop: 'newOrderState',
              width: 120,
            },
          },
          {
            name: 'oldOrderId',
            columnProps: {
              label: '原订单ID',
              prop: 'oldOrderId',
            },
            render: ({ row }) => {
              const params = {
                path: '/underLease/underLeaseOrder/personalDetail',
                query: {
                  id: row.oldOrderId,
                  orderType: 'personal',
                },
              }
              return <span class="a-hover-link" onClick={() => this.$router.push(params)} > {row.oldOrderId} </span>
            },
          },
          {
            name: 'renewalOrderStateTime',
            columnProps: {
              label: '续约计租开始日',
              prop: 'renewalOrderStateTime',
              width: 180,
            },
          },
          {
            name: 'renewalOrderEndTime',
            columnProps: {
              label: '续约计租结束日',
              prop: 'renewalOrderEndTime',
              width: 180,
            },
          },
          {
            name: 'renewalOrderCreateTime',
            columnProps: {
              label: '续约单创建时间',
              prop: 'renewalOrderCreateTime',
              width: 180,
            },
          },
          {
            name: 'createUserName',
            columnProps: {
              label: '订单创建人',
              prop: 'createUserName',
              width: 180,
            },
          },
          {
            name: 'operate',
            columnProps: {
              label: '操作',
              fixed: 'right',
              width: 240,
            },
            maxShowLength: operateMaxShowLength,
            getOperateList: ({ row }) => {
              const { oldOrderId, newOrderId, newOrderStateValue } = row

              const queryObj = {
                oldOrderId,
                orderId: newOrderId,
              }
              const confirmOrderBtnAction = () => {
                this.$router.push({
                  path: PERSONAL_ADD_PATH,
                  query: queryObj,
                })
              }
              const confirmOrderBtn = {
                name: 'confirmOrder',
                label: '合同签署',
                action: confirmOrderBtnAction,
              }

              const btns = []
              if (
                this.judgePermission('rent_order_confirm') &&
                newOrderStateValue === ORDER_STATES.confirmOrderWaiting.value
              ) {
                btns.push(confirmOrderBtn)
              }

              return btns
            },
            type: 'operate',
          },
        ],
        pagination: {
          pageSizes: [10, 20, 30, 50],
        },
        apiFn: getSensitiveRentOrderRenewalList,
      },
    },
    enterpriseConfigData: {
      formData: {
        list: [
          {
            el: 'input',
            itemConfig: {
              label: '订单ID',
              prop: 'orderId',
            },
            directives: [{ name: 'number', arg: 'integer', value: 18 }],
            elConfig: {
              placeholder: '请输入',
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: true,
              remoteMethod: (query) => {
                this.getCustomerList(query)
              },
              placeholder: '请输入',
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              events: {
                'visible-change': (visible) => {
                  if (!visible) {
                    this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'customerId', data: [] })
                  }
                },
              },
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
            },
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约单创建时间',
              prop: 'createTime',
            },
            elConfig: {},
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约后合同结束日',
              prop: 'renewalEndDate',
            },
            elConfig: {},
          },
        ],
        dealWithSearch: this.dealWithSearchOfEnterprise,
      },
      tableData: {
        columns: [
          {
            name: 'orderId',
            columnProps: {
              label: '订单ID',
              prop: 'orderId',
            },
            render: ({ row }) => {
              const params = {
                path: '/underLease/underLeaseOrder/primaryOrderDetail',
                query: {
                  id: row.orderId,
                },
              }
              return <span class="a-hover-link" onClick={() => this.$router.push(params)} > {row.orderId} </span>
            },
          },
          {
            name: 'customerName',
            columnProps: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
          {
            name: 'oldContractStartDate',
            columnProps: {
              label: '原合同开始时间',
              prop: 'oldContractStartDate',
            },
          },
          {
            name: 'oldContractEndDatete',
            columnProps: {
              label: '原合同结束时间',
              prop: 'oldContractEndDate',
            },
          },
          {
            name: 'renewalContractEndDate',
            columnProps: {
              label: '续约后合同结束时间',
              prop: 'renewalContractEndDate',
            },
          },
          {
            name: 'gmtCreate',
            columnProps: {
              label: '续约单创建时间',
              prop: 'gmtCreate',
            },
          },
        ],
        pagination: {
          pageSizes: [10, 20, 30, 50],
        },
        apiFn: getLeaseOrderRenewalList,
      },
    },
    enterpriseSubConfigData: {
      formData: {
        list: [
          {
            el: 'select',
            itemConfig: {
              label: '车牌号',
              prop: 'carId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: true,
              remoteMethod: (query) => {
                this.gerCarList(query)
              },
              placeholder: '请输入',
              options: {
                label: 'plateNo',
                value: 'id',
                list: [],
              },
              events: {
                'visible-change': (visible) => {
                  if (!visible) {
                    this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
                  }
                },
              },
            },
          },
          {
            el: 'select',
            itemConfig: {
              label: '客户名称',
              prop: 'customerId',
            },
            elConfig: {
              filterable: true,
              remote: true,
              reserveKeyword: true,
              clearable: true,
              defaultFirstOption: true,
              remoteMethod: (query) => {
                this.getCustomerList(query)
              },
              placeholder: '请输入',
              options: {
                label: 'customerName',
                value: 'id',
                list: [],
              },
              events: {
                'visible-change': (visible) => {
                  if (!visible) {
                    this.$refs.baseListManagement?.setItemData({ elConfigKey: 'list', key: 'customerId', data: [] })
                  }
                },
              },
              jsxRender: (option) => {
                return <CustomerNameOptionItem data={option} />
              },
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '续约订单ID',
              prop: 'newOrderId',
            },
            directives: [{ name: 'number', arg: 'integer', value: 18 }],
            elConfig: {
              placeholder: '请输入',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '原订单ID',
              prop: 'oldOrderId',
            },
            directives: [{ name: 'number', arg: 'integer', value: 18 }],
            elConfig: {
              placeholder: '请输入',
            },
          },
          {
            itemConfig: {
              prop: 'brandSeriesModel',
            },
            elConfig: {
              showModel: true,
              filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
            },
            render: 'CarBrandSeriesModel',
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约单创建时间',
              prop: 'gmtCreate',
            },
            elConfig: {},
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约计租开始日',
              prop: 'renewalStartTime',
            },
            elConfig: {},
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '续约计租结束日',
              prop: 'renewalEndTime',
            },
            elConfig: {},
          },
        ],
        dealWithSearch: this.dealWithSearchOfEnterpriseSub,
        customizeReset: this.resetBrandSeriesModel,
      },
      tableData: {
        columns: [
          {
            name: 'newOrderId',
            columnProps: {
              label: '续约订单ID',
              prop: 'newOrderId',
              width: 150,
            },
            render: ({ row }) => {
              const params = {
                path: '/underLease/underLeaseOrder/enterpriseChildDetail',
                query: {
                  id: row.newOrderId,
                  orderType: 'enterChild',
                },
              }
              return <span class="a-hover-link" onClick={() => this.$router.push(params)} > {row.newOrderId} </span>
            },
          },
          {
            name: 'plateNo',
            columnProps: {
              label: '车牌号',
              prop: 'plateNo',
              width: 100,
            },
          },
          {
            name: 'brandName',
            columnProps: {
              label: '品牌',
              prop: 'brandName',
            },
          },
          {
            name: 'seriesName',
            columnProps: {
              label: '车系',
              prop: 'seriesName',
            },
          },
          {
            name: 'carModel',
            columnProps: {
              label: '车型',
              prop: 'carModel',
              width: 160,
            },
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
          {
            name: 'customerName',
            columnProps: {
              label: '客户名称',
              prop: 'customerName',
              width: 110,
            },
            showEllipsisTooltip: true,
            limitEllipsisLine: 1,
          },
          {
            name: 'rentCategory',
            columnProps: {
              label: '租赁类别',
              prop: 'rentCategory',
            },
          },
          {
            name: 'newOrderState',
            columnProps: {
              label: '续约订单状态',
              prop: 'newOrderState',
              width: 150,
            },
          },
          {
            name: 'oldOrderId',
            columnProps: {
              label: '原订单ID',
              prop: 'oldOrderId',
            },
            render: ({ row }) => {
              const params = {
                path: '/underLease/underLeaseOrder/enterpriseChildDetail',
                query: {
                  id: row.oldOrderId,
                  orderType: 'enterChild',
                },
              }
              return <span class="a-hover-link" onClick={() => this.$router.push(params)} > {row.oldOrderId} </span>
            },
          },
          {
            name: 'renewalOrderStateTime',
            columnProps: {
              label: '续约计租开始日',
              prop: 'renewalOrderStateTime',
              width: 180,
            },
          },
          {
            name: 'renewalOrderEndTime',
            columnProps: {
              label: '续约计租结束日',
              prop: 'renewalOrderEndTime',
              width: 180,
            },
          },
          {
            name: 'renewalOrderCreateTime',
            columnProps: {
              label: '续约单创建时间',
              prop: 'renewalOrderCreateTime',
              width: 180,
            },
          },
        ],
        pagination: {
          pageSizes: [10, 20, 30, 50],
        },
        apiFn: getRentOrderRenewalList,
      },
    },
  }
}
